import React, { useState } from "react";
import { Tooltip } from "react-tippy";
import styles from "./atoms.Pills.OrderPills.module.scss";
import i18n from "i18n";

const tooltipStyle = {
  background: "#FFFFFF",
  boxShadow: "0px 3px 6px #00000029",
  height: "45px",
  padding: "0 15px",
  color: "#494F66",
  fontFamily: "Roboto-Light",
  fontSize: "18px",
  borderRadius: "15px",
  display: "flex",
  alignItems: "center",
};

const mapping = {
  DRA: i18n.t("orders.status.DRA"),
  PEN: i18n.t("orders.status.PEN"),
  PRO: i18n.t("orders.status.PRO"),
  SUP: i18n.t("orders.status.SUP"),
  DISP: i18n.t("orders.status.DISP"),
  REJ: i18n.t("orders.status.REJ"),
  COM: i18n.t("orders.status.COM"),
};

export const OrderStatePill = ({ state, big }) => {
  return (
    <div className={styles["order-state-pill-container"]}>
      {state && (
        <div
          className={
            `${styles["order-state-pill-inner"]} ` +
            `${styles[state.toLowerCase()] || ""} ` +
            `${big ? styles["big"] : ""}`
          }
          key={state}
        >
          {" "}
          <p>{mapping[state]}</p>
        </div>
      )}
    </div>
  );
};

export default OrderStatePill;
